import { render } from "./StepComms.vue?vue&type=template&id=cf769f58&scoped=true"
import script from "./StepComms.vue?vue&type=script&lang=js"
export * from "./StepComms.vue?vue&type=script&lang=js"

import "./StepComms.vue?vue&type=style&index=0&id=cf769f58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf769f58"]])

export default __exports__